import React from 'react';

export default (
  <div style={{margin: '10px'}}>
    <h1>Política de Privacidad</h1>
    <br />
    <p>
      <strong>Le damos la bienvenida a la Pol&#237;tica de privacidad de </strong>
    </p>
    <p>
      <strong>Whitewater The Teaming Company</strong>
    </p>
    <p>
      Cuando utiliza los servicios de Whitewater TTC, nos conf&#237;a su informaci&#243;n personal.
    </p>
    <p>
      El objetivo de esta Pol&#237;tica de privacidad es informarle sobre los datos que recolectamos y lo que hacemos con ellos. Para contestar los formularios
      es necesario que Usted est&#233; de acuerdo con la presente pol&#237;tica y marque el recuadro de &#8220;Aceptar&#8221; que se encuentra al final.
    </p>
    <p>
      Su privacidad es importante para Whitewater TTC y si requiere mayor informaci&#243;n puede ponerse en contacto con el consultor que lo est&#225;
      atendiendo.
    </p>
    <br />
    <p>
      <strong>Pol&#237;tica de Privacidad</strong>
    </p>
    <p>
      Cuando comparte su informaci&#243;n personal con nosotros podemos identificar y mejorar los servicios que le brindamos.
    </p>
    <p>
      Su informaci&#243;n personal ser&#225; utilizada para alguna de las siguientes finalidades: capacitaci&#243;n y desarrollo, coaching, reclutamiento y
      selecci&#243;n, apreciaci&#243;n de perfiles de personalidad.
    </p>
    <p>
      La presente Pol&#237;tica de privacidad describe:
    </p>
    <p>
      <ul>
        <li>Qu&#233; datos recolectamos</li>
        <li>C&#243;mo utilizamos esos datos</li>
      </ul>
    </p>
    <br />
    <p>
      <strong>Datos recolectados por Whitewater</strong>
    </p>
    <p>
      Recopilamos informaci&#243;n para ofrecer mejores servicios a todos nuestros usuarios: desde informaci&#243;n b&#225;sica, como su edad, hasta
      informaci&#243;n de sus opiniones personales sobre temas de personalidad o negocio.
    </p>
    <p>
      Recolectamos la siguiente informaci&#243;n para identificar su Perfil de Personalidad XTNA&#174;, Perfil de Personalidad Five Factors&#174; y Perfil
      Motivacional APM&#174;
    </p>
    <ul>
      <li>
        Nombre completo.
      </li>
      <li>
        Correo electr&#243;nico.
      </li>
      <li>
        Edad.
      </li>
      <li>
        Sexo.
      </li>
      <li>
        Empresa u organizaci&#243;n en donde trabaja o instituci&#243;n educativa en la que estudia.
      </li>
      <li>
        Ciudad, estado y pa&#237;s en donde vive.
      </li>
    </ul>
    <p>
      Esta informaci&#243;n se asocia a su perfil de personalidad y para obtener este perfil solicitamos sus respuestas personales respeto a su estilo de
      conducta o su forma de pensar. Respecto al uso que hacemos con sus datos y respuestas por favor lea la siguiente secci&#243;n &#8220;C&#243;mo utilizamos
      los datos recolectados&#8221;.
    </p>
    <p>
      Recolectamos la siguiente informaci&#243;n para identificar el perfil de su equipo de trabajo u organizaci&#243;n Team Profile Assessment&#174;:
    </p>
    <ul>
      <li>
        Nombre de la empresa u organizaci&#243;n.
      </li>
      <li>
        Equipo al que pertenece.
      </li>
      <li>
        Puesto que desempe&#241;a.
      </li>
      <li>
        Antig&#252;edad en el puesto y/u organizaci&#243;n.
      </li>
      <li>
        Sexo.
      </li>
    </ul>
    <p>
      Como podr&#225; notar, para obtener los resultados de Team Profile Assessment&#174; no solicitamos su nombre ni edad. Respecto al uso que hacemos con sus
      datos y respuestas por favor lea la siguiente secci&#243;n &#8220;C&#243;mo utilizamos los datos recolectados&#8221;.
    </p>
    <br />
    <p>
      <strong>C&#243;mo utilizamos los datos recolectados</strong>
    </p>
    <p>
      Utilizamos sus datos y respuestas personales para generar los perfiles de personalidad o el perfil de Equipo al que pertenece.
    </p>
    <p>
      Sus respuestas particulares respecto a su conducta o sus opiniones sobre el equipo de trabajo en el que participa NO se comparte ni con los consultores que
      lo atienden, tampoco se comparte con personal de la empresa con la que trabaja (jefes o personal de recursos humanos).
    </p>
    <p>
      Tambi&#233;n usamos la informaci&#243;n para efectos estad&#237;sticos necesarios para la actualizaci&#243;n de los baremos de personalidad como:
    </p>
    <ul>
      <li>
        Perfil de personalidad de hombres mayores de 30 a&#241;os.
      </li>
      <li>
        Perfil de personalidad de mujeres en puestos ejecutivos.
      </li>
      <li>
        Perfil de quipos de trabajo en plantas de producci&#243;n de pa&#237;ses determinados.
      </li>
      <li>
        Similitudes y diferencias entre equipos comerciales y equipos de tecnolog&#237;a.
      </li>
    </ul>
    <br />
    <p>
      <strong>Seguridad de los datos</strong>
    </p>
    <p>
      Whitewater lleva a cabo el tratamiento de los datos y respuestas personales en sus servidores, que est&#225;n ubicados en Estados Unidos.
    </p>
    <p>
      Nos esforzamos por proteger a Whitewater TTC y a nuestros usuarios frente a cualquier modificaci&#243;n, divulgaci&#243;n o destrucci&#243;n no autorizada
      de los datos que conservamos o frente al acceso no autorizado a los mismos. En particular:
    </p>
    <p>
      <ul>
        <li>Encriptamos muchos de nuestros servicios <a href="https://support.google.com/websearch/answer/173733?hl=es">mediante el protocolo SSL</a>.</li>
        <li>Posibilitamos la seguridad de acceso mediante un &#250;nico c&#243;digo de seguridad generado de forma exclusiva para Usted.</li>
        <li>Revisamos nuestra pol&#237;tica en materia de recogida, almacenamiento y tratamiento de datos, incluyendo las medidas de seguridad f&#237;sicas, para impedir el acceso no autorizado a nuestros sistemas.</li>
        <li>Limitamos el acceso de los consultores y empleados de Whitewater TTC a la informaci&#243;n personal que deben procesar para obtener los reportes correspondientes de personalidad y nos aseguramos de que cumplan las estrictas obligaciones de confidencialidad contractuales y de que est&#233;n sujetos a las condiciones disciplinarias pertinentes o al despido si no cumplen dichas obligaciones.</li>
       <li>Nuestra Pol&#237;tica de Privacidad no regula las actividades de tratamiento de datos de otras empresas y organizaciones que anuncien nuestros servicios y puedan emplear cookies, contadores de visitas y otras tecnolog&#237;as para publicar y ofrecer anuncios relevantes.</li>
      </ul>
    </p>
    <br />
    <p>
      <strong>Mantenemos la privacidad y la seguridad de tu informaci&#243;n personal, sobre la que tienes todo el control.</strong>
    </p>
    <p>
      <strong></strong>
    </p>
    <br />
    <br />
    <p>
      &#169; 2015 Whitewater The Teaming Company
    </p>
    <p>
      &#169; 2015 Los Expertos Entrenamiento Especializado, S.C.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/App/questionnaires/PrivacyPolicy.jsx